export default class DescriptiveTextRenderOptions {
  // eslint-disable-next-line no-useless-constructor
  constructor(public speed?: number) {}
}
